import { partial } from '../../../../../../util/translation/translation';

const validate = (values) => {
  const p = partial('validateErrors');
  const errors = {};

  if (!values.ticketState) {
    errors.ticketState = p('ticketSaleCantBeEmpty');
  }

  if (!values.priceGroup) {
    errors.priceGroup = p('priceGroupFieldCantBeEmpty');
  }

  if (!values.owner) {
    errors.owner = p('ownerFieldCantBeEmpty');
  }

  if (!values.user) {
    errors.user = p('userFieldCantBeEmpty');
  }

  return errors;
};

export default validate;
